import { StoreApi } from './instances';

// We have a specific product object comming from store
export interface NyProduct {
  description: string;
  id: number;
  name: string;
  slug: string;
  sku: string;
}
export const getNYProducts = async () => {
  const products = await StoreApi.get<NyProduct[]>(`/v1/products/ny_products`);

  return products.data;
};
